import React, { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle, MapPin, Clock, Phone } from "lucide-react";
import { API } from "../context/OrderContext";
import { Seo } from "../components/Seo";
import { ShareButton } from "../components/ShareButton";
import { DAYS, TIME_SLOTS, formatPhone, telHref } from "../lib/menu";

export default function Contact() {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    axios.get(`${API}/config`).then((r) => setCfg(r.data)).catch(() => {});
  }, []);
  const wa = cfg?.whatsapp_number || "31644582821";

  return (
    <div className="max-w-[900px] mx-auto w-full px-6 py-16 flex flex-col items-center text-center">
      <Seo
        title="Contact & afhalen | De Zeeuwse Tori"
        description="Afhalen bij De Zeeuwse Tori — Duke Ellingtonstraat 109, Middelburg. Bel of app ons direct."
        image="og-contact.jpg"
        path="/contact"
      />
      <h1 className="text-4xl sm:text-5xl font-[700] text-[#0D3B4C] tracking-tight">Contact</h1>
      <p className="mt-3 text-lg md:text-xl font-[600] text-[#0D3B4C]">Bel of app ons direct.</p>

      <div className="mt-8 flex flex-col sm:flex-row items-center gap-4">
        <a
          href={telHref(wa)}
          data-testid="contact-call"
          className="inline-flex items-center gap-3 bg-[#B71C1C] text-white font-[700] uppercase tracking-wider py-5 px-10 text-lg hover:bg-[#8E1515] transition-colors"
        >
          <Phone size={22} /> Bel {formatPhone(wa)}
        </a>
        <a
          href={`https://wa.me/${wa}`}
          target="_blank"
          rel="noreferrer"
          data-testid="contact-whatsapp"
          className="inline-flex items-center gap-3 bg-[#1B6B2E] text-white font-[700] uppercase tracking-wider py-5 px-10 text-lg hover:bg-[#144F22] transition-colors"
        >
          <MessageCircle size={22} /> App ons via WhatsApp
        </a>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-12 w-full text-left">
        <div className="border-2 border-[#E8F5E9] p-6 flex items-start gap-3">
          <Phone className="text-[#1B6B2E] flex-shrink-0" />
          <div>
            <p className="font-[600] text-[#0D3B4C]">Telefoon</p>
            <a href={telHref(wa)} data-testid="contact-phone-number" className="font-[400] text-[#1B6B2E] underline">{formatPhone(wa)}</a>
          </div>
        </div>
        <div className="border-2 border-[#E8F5E9] p-6 flex items-start gap-3">
          <MapPin className="text-[#1B6B2E] flex-shrink-0" />
          <div>
            <p className="font-[600] text-[#0D3B4C]">Ophaaladres</p>
            <p className="font-[400] text-[#0D3B4C]">Duke Ellingtonstraat #109, 4337XT, Middelburg, Zeeland, Nederland</p>
          </div>
        </div>
        <div className="border-2 border-[#E8F5E9] p-6 flex items-start gap-3">
          <Clock className="text-[#1B6B2E] flex-shrink-0" />
          <div>
            <p className="font-[600] text-[#0D3B4C]">Ophaaldagen & tijden</p>
            <p className="font-[400] text-[#0D3B4C]">{DAYS.join(" · ")}</p>
            <p className="font-[400] text-[#0D3B4C]">{TIME_SLOTS.join(" · ")}</p>
          </div>
        </div>
      </div>

      <p className="mt-10 font-[400] text-[#0D3B4C] text-sm">
        KVK: {cfg?.kvk_number || "42115378"} · BTW: {cfg?.btw_number || "NL005505789B34"}
      </p>
      <ShareButton slug="contact" title="Contact & afhalen | De Zeeuwse Tori" label="Deel deze pagina" className="mt-8 inline-flex items-center gap-2 border-2 border-[#1B6B2E] text-[#1B6B2E] font-[700] uppercase tracking-wider py-3 px-7 hover:bg-[#1B6B2E] hover:text-white transition-colors" />
    </div>
  );
}
